import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSubscription } from "../context/SubscriptionContext";
import "../Css/Dashboard.css";

const CheckoutSuccess = () => {
  const location = useLocation();
  const { profile } = useSubscription();
  const { planName, planId } = location.state || {};
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (profile?.plan === planId) {
      setConfirmed(true);
    }
  }, [profile, planId]);

  useEffect(() => {
    const timer = setTimeout(() => setConfirmed(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="dashboardPage" style={{ textAlign: "center" }}>
      <div style={{ maxWidth: 500, margin: "0 auto", paddingTop: "3em" }}>
        <div style={{ fontSize: "4rem", marginBottom: "0.3em" }}>🎉</div>
        <h1
          style={{
            fontFamily: "Poppins, sans-serif",
            fontSize: "2rem",
            color: "#301924",
            marginBottom: "0.4em",
          }}
        >
          Payment Successful!
        </h1>
        <p
          style={{
            fontFamily: "Poppins, sans-serif",
            color: "#555",
            fontSize: "1.05rem",
            marginBottom: "1.5em",
          }}
        >
          {planName
            ? `You're now on the ${planName} plan. Welcome aboard!`
            : "Your subscription is now active. Welcome aboard!"}
        </p>

        {!confirmed && (
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              color: "#888",
              fontSize: "0.9rem",
              marginBottom: "1.5em",
            }}
          >
            Confirming your subscription...
          </p>
        )}

        {confirmed && (
          <div className="dashboardActions" style={{ justifyContent: "center" }}>
            <Link to="/dashboard" className="dashBtn">
              <span>Go to Dashboard</span>
            </Link>
            <Link to="/pricing" className="dashBtnOutline">
              View Plans
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutSuccess;
